import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const COOKIE_CONSENT_KEY = 'art_throng_cookie_consent';

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);
  const [animateOut, setAnimateOut] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!consent) {
      const timer = setTimeout(() => setVisible(true), 800);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'accepted');
    dismiss();
  };

  const handleDecline = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'declined');
    dismiss();
  };

  const dismiss = () => {
    setAnimateOut(true);
    setTimeout(() => setVisible(false), 400);
  };

  if (!visible) return null;

  return (
    <div
      className={`fixed bottom-6 left-1/2 -translate-x-1/2 z-[9999] w-[calc(100%-2rem)] max-w-2xl transition-all duration-400 ${
        animateOut
          ? 'opacity-0 translate-y-6 pointer-events-none'
          : 'opacity-100 translate-y-0'
      }`}
      style={{ transition: 'opacity 0.4s ease, transform 0.4s ease' }}
    >
      <div className="bg-[#2B2B2B] rounded-2xl px-6 py-5 flex flex-col sm:flex-row items-start sm:items-center gap-4">
        {/* Icon */}
        <div className="w-10 h-10 flex items-center justify-center shrink-0 bg-[#8B9B7E]/20 rounded-full">
          <i className="ri-cookie-line text-[#8B9B7E] text-xl"></i>
        </div>

        {/* Text */}
        <div className="flex-1 min-w-0">
          <p className="text-white text-sm font-medium mb-0.5">We use cookies</p>
          <p className="text-gray-400 text-xs leading-relaxed">
            We use cookies to enhance your browsing experience and analyse our traffic. By clicking &quot;Accept&quot;, you consent to our use of cookies. Read our{' '}
            <Link
              to="/privacy-policy"
              className="text-[#8B9B7E] underline hover:text-[#9daf90] transition-colors"
            >
              Privacy Policy
            </Link>
            .
          </p>
        </div>

        {/* Actions */}
        <div className="flex items-center gap-2 shrink-0 w-full sm:w-auto">
          <button
            onClick={handleDecline}
            className="flex-1 sm:flex-none px-4 py-2 rounded-full text-gray-400 hover:text-white border border-gray-600 hover:border-gray-400 text-sm font-medium transition-all whitespace-nowrap cursor-pointer"
          >
            Decline
          </button>
          <button
            onClick={handleAccept}
            className="flex-1 sm:flex-none px-5 py-2 rounded-full bg-[#8B9B7E] text-white hover:bg-[#7a8a6d] text-sm font-medium transition-all whitespace-nowrap cursor-pointer"
          >
            Accept All
          </button>
        </div>
      </div>
    </div>
  );
}
